<template>
    <div class="d-flex flex-column h-100 justify-content-between py-4">

        <div>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled" @click="toggleAddPayment">Payments</button>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled || accessPermissionFilter(['restricted']) || isReservationReadOnly && reservation.status != 5 || isCancellingReservation" @click="rebookReservation">Rebook</button>
            <button class="w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled || accessPermissionFilter(['restricted']) || isReservationReadOnly && reservation.status != 5 && reservation.status != -5 || isCancellingReservation" @click="deleteReservation">Cancel Booking</button>
            <button v-if="featureFlags.showRefunds" class="w-100 w-100 mb-2 bg-lightest color-1 text-center font-weight-600 py-3 border-light radius-normal pointer" :class="{'opacity-50 notAllowed':disableRefund}" :disabled="disabled || accessPermissionFilter(['restricted']) || isReservationReadOnly && reservation.status != 5 && reservation.status != -5" @click="refundReservation">{{ refundBtnLabel }}</button>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled" @click="sendTicket">{{isSendingTicket? 'Sending Email':'Send Email'}}</button>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled || isReservationReadOnly && reservation.status != -5" @click="viewTicket">{{isGeneratingViewTicket? 'Generating ticket':'View Ticket'}}</button>
        </div>

        <div>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :class="{'opacity-50 notAllowed':unsavedChanges}" v-if="showInvoiceBtn" :disabled="disabled || isSavingReservation || getIsCreatingInvoice" @click="startCreateInvoice">{{getIsCreatingInvoice? 'Invoicing...':'Invoice'}}</button>
            <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled || isSavingReservation || isSendingTicketAndPrint" @click="saveReservation({printTicket:true, closeModal:false})">{{isSendingTicketAndPrint? 'Printing...':'Print'}}</button>
            <button class="w-100 w-100 mb-2 bg-color-3 lightest text-center font-weight-600 py-3 border-light radius-normal pointer" :disabled="disabled || isSavingReservation || isSendingTicketAndPrint" @click="saveReservation({printTicket:false, closeModal:false})">{{isSavingReservation? 'Saving...':'Save'}}</button>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PrintJs from 'print-js'
import {eventHub} from '@/main'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    data: function() {
        return {
            isSendingTicket: false,
            isSendingTicketAndPrint: false,
            isGeneratingViewTicket: false,
            isSavingReservation: false,
            isCancellingReservation: false,
        }
    },
    props: {
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showAddPayment: {
            type: Boolean
        }
    },
    created: function () {
        this.eventHub.$on('cancelReservation',(data)=>{
            this.deleteReservation()
        });
        this.eventHub.$on('refundReservation',(data)=>{
            this.refundReservation()
        });
        this.eventHub.$on('saveReservation',(data)=>{
            this.saveReservation()
        });
    },
    beforeDestroy() {
        this.eventHub.$off('cancelReservation');
        this.eventHub.$off('refundReservation');
        this.eventHub.$off('saveReservation');
    },
    computed: {
        ...mapGetters([
            'account',
            'getIsCreatingInvoice',
            'getCompanySettings',
            'getShowInvoiceOption'
        ]),
        refundBtnLabel: function () {
            return (this.reservation.refunds && this.reservation.refunds.length > 0 && this.reservation.refunds.filter(refund => !refund.id).length > 0)? 'Edit refund' : 'Refund'
        },
        disableRefund: function () {
            return this.reservation.updateFlags.extras == true || this.reservation.updateFlags.pax == true
        },
        showInvoiceBtn: function () {
            return this.getShowInvoiceOption? this.getShowInvoiceOption : false
        },
        unsavedChanges: function () {
            let output = false
            for (var key in this.reservation.updateFlags) {
               if (this.reservation.updateFlags.hasOwnProperty(key)) {
                  if (this.reservation.updateFlags[key] == true){
                      output = true
                  }
               }
            }
            return output
        },
    },
    mixins:[
        reservationsMixin,
    ],
    methods: {
        ...mapActions([
            'updateExistingReservation',
            'closeModal',
            'cancelExistingReservation',
            'setReservation',
            'createInvoice',
            'openModal',
            'setSelectedReservation'
        ]),
        printTicket: function() {
            printJS('static/images/ticket.png')
        },
        saveAndSend: function() {
            console.log('save and send');
        },
        saveReservation: async function(options) {
            if(!options){
                options = {
                    closeModal: false
                }
            }
            
            //if is saving do nothing
            if(this.isSavingReservation || this.isSendingTicketAndPrint){
                return false
            }

            // Validate transport
            if(!this.validateTranposrts()){
                this.$toasted.error('Check pickups, information missing')
                return false
            }

            options.closeModal = (options.closeModal == undefined)? true : options.closeModal
            if(options.printTicket){
                this.isSendingTicketAndPrint = true
            } else {
                this.isSavingReservation = true
            }

            // if changing status from not cancelled to cancelled trigger cancellation popup *******
            let proceedToSave = true
            if(this.reservation.status != this.reservation.originalStatus){
                await this.checkStatusChange().then(acceptedStatusChange => {
                    if(acceptedStatusChange == false){
                        //abort save reservation
                        proceedToSave = false
                        return false
                    } else {
                        //if accepted popup from cancelation
                        if(this.reservation.status == '-5'){
                            options.closeModal = false
                        }
                    }
                })
            }

            if(proceedToSave == false){
                this.isSavingReservation = false
                this.isSendingTicketAndPrint = false
                return false
            }
            // *************************************************************************************


            return this.updateExistingReservation({
                supplierId: this.account.supplierId,
                reservation: this.reservation
            }).then(response => {
                if(response.status && response.status == 200){
                    this.isSavingReservation = false
                    this.isSendingTicketAndPrint = false
                    
                    this.reservation.originalStatus = this.reservation.status
                    
                    this.$emit('updateThisReservation', response.data)


                    eventHub.$emit('updateReservationsList', this.reservation);
                    this.$emit('updateReservationsList', response.data);

                    if(options.closeModal){
                        this.closeModal();
                    }


                    if(options.printTicket){
                        axios.get('/api/booking/GetTicket', {
                            params: {
                                bookingId: response.data.id
                            }
                        }).then(response => {
                            this.openByteArrayNewTab(response.data)
                        })

                    }


                } else {
                    this.isSavingReservation = false
                    this.isSendingTicketAndPrint = false
                }
            }).catch(error => {
                this.isSavingReservation = false
                this.isSendingTicketAndPrint = false
            })
        },
        deleteReservation: function() {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            if(this.isCancellingReservation == true){
                return false
            }
            
            // is (OTA) GetYourGuide or Pluralo Locals - ask for cancelation reason
            if(this.reservation.channelType == 202){
                this.openModal('ReservationCancelReason')

            } else {
                this.setReservationToCancel(false)
            }


        },
        refundReservation: function() {
            if(this.disableRefund){
                this.$dialog.alert('There are unsaved changes, you must save the reservation before refunding.', {okText: 'OK'})
                .then(function () {

                })
                .catch(function () {
                });

                return false
            }
            this.openModal('ReservationRefundGeneral')
        },
        rebookReservation: function() {

            if(this.isReservationReadOnly && this.reservation.status != 5){
                this.readOnlyShowMessage()
                return false
            }
            
            if(this.reservation.status == -6 || this.reservation.status == 50 || this.reservation.status == -50){
                this.$toasted.info('Unable to rebook this reservation')
                return false
            }
            
            this.setReservation(this.reservation);
            this.$router.push('/reservation/reschedule/'+this.reservation.event.product.id);
            this.closeModal();
        },
        toggleAddPayment: function() {
            this.$emit('toggleAddPayment')
        },
        viewTicket: function() {
            if(this.isReservationReadOnly && this.reservation.status != -5){
                this.readOnlyShowMessage()
                return false
            }

            if(this.isGeneratingViewTicket){
                this.$toasted.info('Generating ticket to view, please wait');
            }

            this.isGeneratingViewTicket = true
            axios.get('api/booking/GetTicket',{
                params:{
                    bookingId: this.reservation.id
                }
            }).then( response => {

                this.isGeneratingViewTicket = false

                this.openByteArrayNewTab(response.data)
            })
        },
        sendTicket: function() {
            if(this.isReservationReadOnly && this.reservation.status != 5){
                this.readOnlyShowMessage()
                return false
            }

            if(this.isSendingTicket){
                this.$toasted.info('Sending ticket to '+ this.reservation.customer.email+' please wait');
                return false
            }

            this.isSendingTicket = true
            this.saveReservation({
                printTicket: false,
                closeModal: false
            }).then(r => {

                this.$toasted.info('Sending to '+ this.reservation.customer.email);
                axios.get('api/Booking/SupplierSendTicket',{
                    params:{
                        bookingId: this.reservation.id
                    }
                }).then( response => {
                    this.isSendingTicket = false
                    this.$toasted.success('Sent');
                }).catch(error => {
                    this.isSendingTicket = false
                    this.$toasted.error('Sent failed');
                })

            })
        },
        validateTranposrts: function () {
            let allTransportValid = true

            for (let transfer of this.reservation.transport.transfers) {

                var isTransferValid = true

                //validation for non custom
                if(!transfer.isCustom){
                    if(!transfer.route || transfer.route == null || transfer.route == undefined || transfer.route.name == "" || !transfer.route.name){
                        console.log('Route missing');
                        this.$set(transfer, 'errorRoute', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorRoute', false)
                    }

                    if(!transfer.stop){
                        console.log('No selected stop');
                        this.$set(transfer, 'errorStop', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorStop', false)
                        if(!transfer.schedule){
                            this.$set(transfer, 'errorSchedule', true)
                            isTransferValid = false
                            console.log('No time selected');
                        } else {
                            this.$set(transfer, 'errorSchedule', false)
                        }
                    }
                } else {
                    //validate custom transport
                    if(!transfer.stop || transfer.stop == null || transfer.stop == undefined || transfer.stop.name == "" || !transfer.stop.name){
                        this.$set(transfer, 'errorRoute', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorRoute', false)
                    }

                    if(!transfer.exitStop || transfer.exitStop == null || transfer.exitStop == undefined || transfer.exitStop.name == "" || !transfer.exitStop.name ){
                        this.$set(transfer, 'errorStop', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorStop', false)
                    }

                    if(!transfer.schedule || transfer.schedule == null || transfer.schedule == undefined || !transfer.schedule.time ){
                        this.$set(transfer, 'errorTime', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorTime', false)
                    }

                    if(!transfer.schedule || transfer.schedule == null || transfer.schedule == undefined || !transfer.schedule.date ){
                        this.$set(transfer, 'errorDate', true)
                        isTransferValid = false
                    } else {
                        this.$set(transfer, 'errorDate', false)
                    }

                }

                if(!isTransferValid){
                    allTransportValid = false
                }

                this.$set(transfer, 'isValid', isTransferValid)
                this.$forceUpdate()
            }




            return allTransportValid
        },
        checkStatusChange: async function () {
            // console.log('Old status: '+this.reservation.originalStatus+' new status '+this.reservation.status);

            //if reservation is now canceled
            if(this.reservation.status == '-5' && this.reservation.originalStatus != '-5'){
                return await this.cancelReservationPopup()
            }

            return new Promise(resolve => {
                resolve();
            });
        },
        startCreateInvoice: function () {
            if(this.unsavedChanges){
                this.$dialog.alert('There are unsaved changes, you must save the reservation before invoicing.', {okText: 'OK'})
                .then(function () {

                })
                .catch(function () {
                });

                return false
            }

            this.eventHub.$emit('editReservation_toggleCreateInvoice')
            // this.createInvoice(this.reservation.id)
        }

    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SideButtons.vue?37df7060